import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/dyalog': {
    width: 416,
    height: 512,
    paths: [
      {
        d: 'M0 32V151.2H64V96H171.2C284.6 96 352 176.2 352 255.9 352 332 293.4 416 171.2 416H0V480H171.2C331.9 480 416 367.3 416 255.9 416 197.2 393.9 142.5 353.7 101.6 308.9 56 245.7 32 171.2 32H0z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/dyalog.js
// module id = Q9Ib
// module chunks = 144